export default __webpack_public_path__ + "static/media/md-card-bg-fullstack-mern.3430ff35.png";